export default "__VITE_ASSET__DsdlOfTX__"